// Own i18next namespace so rewamp keys can never collide with the legacy "translation" ns.

export const REWAMP_LOCALE_NAMESPACE = "rewamp";

// Closed set: declare a domain here before any component requests it.
export const REWAMP_LOCALE_MODULES = Object.freeze({
  common: "dfsweb-rewamp-common",
  schemes: "dfsweb-rewamp-schemes",
  assets: "dfsweb-rewamp-assets",
  onboarding: "dfsweb-rewamp-onboarding",
  farmerVerify: "dfsweb-rewamp-farmer-verify",
  weather: "dfsweb-rewamp-weather",
  homescreen: "dfsweb-rewamp-homescreen",
  agriInput: "dfsweb-rewamp-agri-input",
  advisories: "dfsweb-rewamp-advisories",
  helpSupport: "dfsweb-rewamp-help-support",
});

// Returns null (not the raw domain) in production so a typo never reaches the network as a module code.
export const resolveModuleCode = (domain) => {
  const code = REWAMP_LOCALE_MODULES[domain];
  if (code) return code;
  if (process.env.NODE_ENV !== "production") {
    throw new Error(
      `[rewamp-localisation] unknown domain "${domain}" — add it to REWAMP_LOCALE_MODULES (src/rewamp/localisation/constants.js) first.`
    );
  }
  return null;
};
